export default __webpack_public_path__ + "static/media/Timeline-GiftBoxes-16.0f9bb1e5.png";